/* eslint-disable */
import Native from "f.component.native";
import "./cart.scss";
import cartTpl from "./cart.ejs";

class ShoppingCart {
  constructor(container, options) {
    this.container = container;
    this.options = options;
    this.init();
  }

  init() {
    this.cartIcon = $(cartTpl());
    this.container.append(this.cartIcon);
    this.initEvent();
  }

  initEvent() {
    var _this = this;
    this.cartIcon.on("click", function (e) {
      // 是否为横屏状态
      const zoomState = $(document.body).hasClass("horizontal");
      if (zoomState && Native.isApp) {
        Native.rotate(0);
      }

      if (_this.options.url) {
        window.open(_this.options.url);
      }
    });
  }

  show() {
    this.cartIcon.animate({ opacity: "1" });
    this.cartIcon.show();
  }

  hide() {
    this.cartIcon.animate({ opacity: "0" });
    this.cartIcon.hide();
  }
}

export default ShoppingCart;



// WEBPACK FOOTER //
// ./app/modules/shoppingCart/index.js